import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface ChangePasswordModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (oldPassword: string, newPassword: string) => Promise<string | null | undefined>;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ show, onClose, onSubmit }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      setError('Vui lòng nhập đủ các trường');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Mật khẩu mới và xác nhận không khớp');
      return;
    }
    setError('');
    setLoading(true);
    const result = await onSubmit(oldPassword, newPassword);
    if (result) {
      setError(result);
    } else {
      onClose();
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Đổi mật khẩu</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Mật khẩu cũ</Form.Label>
            <Form.Control
              type="text"
              value={oldPassword}
              onChange={e => setOldPassword(e.target.value)}
              autoFocus
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Mật khẩu mới</Form.Label>
            <Form.Control
              type="text"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Nhập lại mật khẩu mới</Form.Label>
            <Form.Control
              type="text"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
            />
          </Form.Group>
          {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>Hủy</Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Đang đổi...' : 'Đổi mật khẩu'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePasswordModal;
